import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';

import getUsuarios from '../../../graphql/querys/auth/getUsuarios.graphql';
import activarUsuario from '../../../graphql/mutations/auth/activarUsuario.graphql';

import TablaUsuarios from './TablaUsuarios';
import { errorService } from '../../../graphql/utils/utils';

@compose(
  graphql(getUsuarios, { options: { fetchPolicy: 'network-only' } }),
  graphql(activarUsuario, {
    name: 'activarUsuario',
    options: {
      refetchQueries: [{ query: getUsuarios }],
    },
  })
)
class VerUsuarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
    };

    this.onActivar = this.onActivar.bind(this);
  }

  onActivar(id) {
    //TODO: Hacer el onActivar de las cuentas de usuarios!
    // console.log("Se desea eliminar la persona con id ", id);

    this.props
      .activarUsuario({
        variables: { id: id },
      })
      .then(res => {
        if (res.data.activarUsuario.activado) {
          notification.success({
            message: 'Usuario Activado!',
            description: 'Se ha activado correctamente al usuario',
          });
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de activar a un usuario');
        console.log(err);
        errorService(err, {
          id: id,
        });

        Modal.error({
          title: 'Error a la hora de intentar activar el usuario',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getUsuarios, usuario => {
      return (
        usuario.nombre.toUpperCase().indexOf(this.state.filtro.toUpperCase()) >
          -1 ||
        usuario.apellido
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        usuario.username
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getUsuarios, usuario => {
      return usuario.nombre.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getUsuarios, usuario => {
      return usuario.apellido.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorUsername = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getUsuarios, usuario => {
      return usuario.username.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorOrganismo = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getUsuarios, usuario => {
      if (!usuario.organismo) {
        return null;
      }
      return (
        usuario.organismo.nombre.toUpperCase().indexOf(filtro.toUpperCase()) >
        -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('VOY A RECIBIR PROPS: ', nextProps);
    if (nextProps.data.getUsuarios) {
      this.setState(
        {
          ...this.state,
          listaTotal: nextProps.data.getUsuarios,
        },
        function() {
          this.ordenarLista(1, 10);
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        usuario => {
          return usuario.apellido.toUpperCase();
        },
      ],
      ['asc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  render() {
    let cargando =
      this.state.loading || (this.props.data && this.props.data.loading);

    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaUsuarios
          usuarios={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          filtrarPorUsername={this.filtrarPorUsername}
          filtrarPorOrganismo={this.filtrarPorOrganismo}
          loading={cargando}
        />
      </div>
    );
  }
}

export default withApollo(VerUsuarios);
